export const parseError = async (response: Response) => {
    try {
        const error = await response.json()
        throw error
    } catch (e) {
        console.error(e)
        console.error(response)
        throw e
    }
}
